import React from 'react';
import { TRANSLATION_MODES, FrontendMode } from '../../config/translationModes';
import './ModeSelector.css';

interface ModeSelectorProps {
  selectedMode: FrontendMode;
  onModeChange: (mode: FrontendMode) => void;
  disabled?: boolean;
}

export const ModeSelector: React.FC<ModeSelectorProps> = ({
  selectedMode,
  onModeChange,
  disabled = false,
}) => {
  return (
    <div className="mode-selector" role="tablist" aria-label="Translation mode">
      {TRANSLATION_MODES.map((mode) => {
        const isActive = selectedMode === mode.id;
        return (
          <button
            key={mode.id}
            role="tab"
            type="button"
            className={`mode-tab ${isActive ? 'active' : ''}`}
            aria-selected={isActive}
            onClick={() => onModeChange(mode.id)}
            disabled={disabled}
            title={mode.description}
          >
            <span className="mode-tab-label">{mode.label}</span>
            <span className="mode-tab-description">{mode.description}</span>
          </button>
        );
      })}
    </div>
  );
};
